export const PRIMARY = "#3F0000";
export const SECONDARY = "#FFEBCA";
export const TRINARY = "white";
